import moment from "moment";

export const getFormatDate24Hrs = (dateString) => {
  let momentdate = moment(dateString);
  let date = momentdate?.format("DD/MM/YYYY HH:mm");
  return date;
};
